import {ContactDataModel} from '../person/contact-data.model';
import {XauditModel} from '../xaudit.model';
import {PatientInsuranceDataModel} from './patient-insurance-data.model';
import {PatientContactDataModel} from './patient-contact-data.model';
import {PatientDoctorDataModel} from './patient-doctor-data.model';

export class PatientDataModel extends XauditModel {
  PatientId: string;
  LOCID: number;
  PatientNO: number;
  BirthDate: Date;
  enumOccupationID: string;
  ContactId: string;
  WebID: string;
  // TODO: SHOULD THIS REALLY EXIST???
  //WebPassword: string;
  enumLanguageID: string;
  enumCommMethodID: string;
  isDeceased: boolean;
  ChartNo: number;
  enumPatientAppointmentID: string;
  isDoNotSchedule: boolean;
  isDoNotEverTreatAgain: boolean;
  isSentCollection: boolean;
  isChargeInterest: boolean;
  isOnPaymentPlan: boolean;
  isNoInsurance: boolean;
  BalanceDue: number;
  enumPatientDifficultyLevelID: string = '00000000-0000-0000-0000-000000000000'; // Default to N/A

  dataContact: ContactDataModel = new ContactDataModel();
  dataPatientContacts: PatientContactDataModel[] = [];
  dataPatientDoctors: PatientDoctorDataModel[] = [];

  // Not part of backend reflected model
  dataPatientInsurances: PatientInsuranceDataModel[];
  patientImageUrl: string = 'assets/Images/defaultPatient.PNG';
}
